import React from "react";
import MaskedUtilizationEntry from "./MaskedUtilizationEntry";
import UtilizationEntry from "./UtilizationEntry";
import { LOAD_PRES_CLUB_UTILIZATION_SUCCESS } from "../../redux/actions/ActionTypes";
import DashBoardPanel from "./dashboard/DashboardPanel";
import Loading from "../common/loading/Loading";

function UtilizationLeaders({data, isAdmin}) { 

    return (
        <DashBoardPanel title="Rank By Utilization">
            <Loading api={LOAD_PRES_CLUB_UTILIZATION_SUCCESS} />
            <table className="leaderboard table-hover">
                <thead>
                    <tr>
                        <th className="leader-entry number-data">Rank</th>
                        <th className="leader-entry">Name</th>
                        <th className="leader-entry number-data">Util %</th>
                    </tr>                            
                </thead>
                <tbody>
                    { data.entries.map(p => 
                        p.isSelf || p.isReport || isAdmin ?
                        (<UtilizationEntry rank={p.rank} name={p.firstName + " " + p.lastName} value={p.utilization} isHighlighted={p.isSelf} />)
                        : (<MaskedUtilizationEntry rank={p.rank} value={p.utilization} isHighlighted={p.isSelf} /> ))}
                </tbody>
            </table>   
        </DashBoardPanel>
    );
}

export default UtilizationLeaders;